import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CompanyProvider } from "@/lib/company";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Accounts from "@/pages/Accounts";
import Ledger from "@/pages/Ledger";
import Journals from "@/pages/Journals";
import NewJournal from "@/pages/NewJournal";
import Reports from "@/pages/Reports";
import Setup from "@/pages/Setup";
import Users from "@/pages/Users";
import Station from "@/pages/Station";
import Settlements from "@/pages/Settlements";
import Statements from "@/pages/Statements";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>;
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (!["admin", "accountant"].includes(user.role)) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <CompanyProvider><Layout>{children}</Layout></CompanyProvider>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user && user !== false) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
            <Route path="/ledger/:aid" element={<Protected><Ledger /></Protected>} />
            <Route path="/journals" element={<Protected><Journals /></Protected>} />
            <Route path="/journals/new" element={<Protected><NewJournal /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/station" element={<Protected><Station /></Protected>} />
            <Route path="/statements" element={<Protected><Statements /></Protected>} />
            <Route path="/settlements" element={<Protected><Settlements /></Protected>} />
            <Route path="/setup" element={<Protected><Setup /></Protected>} />
            <Route path="/users" element={<Protected admin><Users /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}
